import React from 'react'
import { useTranslation } from 'react-i18next'
import Container from '~/components/Container'
import Marquee from '~/components/Marquee'
import Typography from '~/components/Typography'
import InvestorsList from './InvestorsList'
import MainInvestorCard from './MainInvestorCard'

const Investors = () => {
  const { t } = useTranslation()

  return (
    <div className="w-full bg-black py-20 text-white lg:rounded-md">
      <Container className="mb-20 flex flex-col gap-y-20">
        <div className="flex flex-col gap-y-6 max-md:text-center">
          <Typography variant="h4">{t('team:investors.title')}</Typography>
          <Typography variant="body2" className="max-w-xl text-white/80">
            {t('team:investors.description')}
          </Typography>
        </div>
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2">
          <MainInvestorCard
            fullName="Stéphane Bancel"
            jobTitle={t('team:investors.members.stephane.job')}
            description={`“${t('team:investors.members.stephane.description')}”`}
          />
          <MainInvestorCard
            fullName="Jean-Claude Marian"
            jobTitle={t('team:investors.members.jeanclaude.job')}
            description={`“${t('team:investors.members.jeanclaude.description')}”`}
          />
        </div>
      </Container>
      <Marquee gradientColor="black">
        <InvestorsList />
      </Marquee>
    </div>
  )
}

export default Investors
